import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

const NavLink = props => {

  const newProps = {
    ...props
  };

  if (props.disabled) {
    newProps.onClick = event => {
      event.preventDefault();
      if (props.onClick) {
        props.onClick(event);
      }
    };
    newProps.className = (props.className || '') + ' disabled';
  }

  return <Link {...newProps} activeClassName='active'/>;
};

NavLink.propTypes = {
  ...Link.propTypes,
  disabled: PropTypes.bool
};

NavLink.defaultProps = {
  onlyActiveOnIndex: false
};

export default NavLink;



// WEBPACK FOOTER //
// ./src/components/NavLink.js